import {
  createFrontendPlugin,
  createRouteRef,
  FrontendPlugin,
  PageBlueprint,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';
import { rootRouteRef } from './routes';
import { RiGithubLine } from '@remixicon/react';

const githubMarketplacePage = PageBlueprint.make({
  params: {
    title: 'Marketplace',
    icon: <RiGithubLine />,
    routeRef: convertLegacyRouteRef(rootRouteRef),
    path: '/marketplace',
  },
});

const githubActions = SubPageBlueprint.make({
  name: 'actions',
  params: {
    title: 'GitHub Actions',
    path: 'github/actions',
    routeRef: createRouteRef(),
    loader: () =>
      import('./components/GithubMarketPlace/').then(m =>
        compatWrapper(<m.GithubMarketplace type="github-action" />),
      ),
  },
});

const githubWorkflows = SubPageBlueprint.make({
  name: 'workflows',
  params: {
    title: 'GitHub Reusable Workflows',
    path: 'github/reusable-workflows',
    routeRef: createRouteRef(),
    loader: () =>
      import('./components/GithubMarketPlace/').then(m =>
        compatWrapper(<m.GithubMarketplace type="github-reusable-workflow" />),
      ),
  },
});

// const policyReporterPage = PageBlueprint.make({
//   params: {
//     path: '/policy-reporter',
//     routeRef: rootRouteRef,
//     title: 'Policy Reporter',
//     icon: <PolicyIcon />,
//   },
// });

export const githubMarketplacePlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'github-marketplace',
  extensions: [githubMarketplacePage, githubActions, githubWorkflows],
  routes: convertLegacyRouteRefs({
    root: rootRouteRef,
  }),
});
